import React from 'react';
import { Stack } from '@moda/om';
import { RefreshedMobileSiteNavMenuLinkItem } from '../RefreshedMobileSiteNavMenuLinkItem';
import { RefreshedMobileSiteNavMenuQuery } from '../../../../generated/types';

type SubItem = NonNullable<
  RefreshedMobileSiteNavMenuQuery['displayPage']
>['data']['tabs'][number]['mainCategories'][number]['mainCategoryItems'][number]['subItems'][number];

interface Props {
  data: SubItem;
  onClose: () => void;
}

export const RefreshedMobileNavMainCategoryItem: React.FC<Props> = ({
  data: { listLinks },
  onClose
}) => {
  if (!listLinks?.length) return null;
  return (
    <Stack className="RefreshedMobileNavMainCategoryItem" space={0}>
      {listLinks?.map((link, index) => (
        <RefreshedMobileSiteNavMenuLinkItem
          key={index}
          url={link.url}
          label={link.label}
          onClick={onClose}
        />
      ))}
    </Stack>
  );
};
